// removed by extract-text-webpack-plugin
module.exports = {"clearBlock":"_3hEdhXdakoKqZyh_u1QJyp","clearButton":"_31WkPxLu-RLARZREtMZTkG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMClearFiltersButton/OMClearFiltersButton.scss
// module id = 1629
// module chunks = 0